import React, {createContext, useContext, useState, ReactNode} from 'react';
import {createPortal} from 'react-dom';
import {CreditPackageData, CreditPricingModal} from "../components/modals/CreditPricingModal";
import {CheckoutModal} from "../components/modals/CheckoutModal";  // Adjust import path

interface ModalContextType {
    isOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const CreditModalProvider: React.FC<{ children: ReactNode }> = ({children}) => {
    const [isCreditOpen, setIsCreditOpen] = useState(false);  // Renamed for clarity
    const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
    const [selectedPackage, setSelectedPackage] = useState<CreditPackageData | null>(null);

    // Centralized purchase handler: transition to checkout
    const handlePurchase = (pkg: CreditPackageData) => {
        setSelectedPackage(pkg);
        setIsCreditOpen(false);  // Close pricing modal
        setIsCheckoutOpen(true); // Open checkout
    };

    const openModal = () => {
        setIsCreditOpen(true);
    };

    const closeModal = () => {
        setIsCreditOpen(false);
    };

    const closeCheckout = () => {
        setIsCheckoutOpen(false);
        setSelectedPackage(null);  // Clean up
        // Optionally trigger any post-checkout logic here (e.g., refresh credits)
    };

    return (
        <ModalContext.Provider value={{isOpen: isCreditOpen, openModal, closeModal}}>
            {children}
            {createPortal(
                <CreditPricingModal
                    isOpen={isCreditOpen}
                    onClose={closeModal}
                    onPurchase={handlePurchase}  // Still centralized
                />,
                document.body
            )}
            {createPortal(
                <CheckoutModal
                    isOpen={isCheckoutOpen}
                    onClose={closeCheckout}
                    selectedPackage={selectedPackage}  // Pass the package data if needed
                />,
                document.body
            )}
        </ModalContext.Provider>
    );
};

export const useCreditModal = () => {
    const context = useContext(ModalContext);
    if (!context) throw new Error('useModal must be used within ModalProvider');
    return context;
};







